import React, {useCallback, useContext} from "react"
import styled from "@emotion/styled"
import { AppContext } from '../../context'

import KeyboardEventHandler from 'react-keyboard-event-handler';
import { HudButton, HudIconButton } from "../molecules/hudButton"
import {themeColor, themeDefault} from '../layout/global-style';
import { IconType } from "../atoms/icon";
import { useIntl } from "gatsby-plugin-intl";

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;  
`
const Label = styled.span`
    text-transform: uppercase;
    min-width: 20px;
    white-space: nowrap;
    min-width: 100px;
`
const getLabel = (index) => `${index}`.padStart(2, '0');

export default () => {
    const {selection, playingVideo, current, setCurrent, pages, pageStep, audio, modeSelection, setTableOfContents} = useContext(AppContext);
    
    const isPrev = current > 0;
    const isNext = current < pages.length - (pageStep)
    const onPrevClick = useCallback( e =>{
        e.stopPropagation();
        setCurrent (current - pageStep);
    },[setCurrent, current, pageStep]);

    const onNextClick = useCallback( e =>{
        e.stopPropagation();
        setCurrent (current + pageStep);
    },[setCurrent, current, pageStep]);

    const onClick = useCallback( e =>{
        e.stopPropagation();
        setTableOfContents (true);
    },[setCurrent, current, pageStep]);

    const currentLabel = getLabel(current/pageStep + 1);
    const totalLabel = getLabel(pages.length/pageStep);
    const pageMode = pageStep === 1;
    const intl = useIntl();
    const prefix = intl.formatMessage({ id: `pagination.label.${pageMode?"page":"spread"}` , defaultMessage:pageMode?"page":"spread"})
    const of = intl.formatMessage({ id: `pagination.label.of`, defaultMessage: 'of'},)

    const label = `${prefix}: ${currentLabel} ${of} ${totalLabel}`;
    
    return selection || playingVideo ? null : (
    <Container>
        <HudIconButton onClick={onPrevClick} disabled={!isPrev || modeSelection}            
            icon={IconType.arrowLeft}
        />
        <HudButton 
            color={modeSelection ? themeDefault.disabled : themeDefault.idlePrimary}
            onClick={onClick}
            fontColor={themeColor.lightGrey}
        >
            <Label>{label}</Label>
        </HudButton>
        <HudIconButton onClick={onNextClick} disabled={!isNext || modeSelection}
            icon={IconType.arrowRight}
        />
        <KeyboardEventHandler
            handleKeys={['left']}
            onKeyEvent={(key, e) => onPrevClick(e)}
            handleFocusableElements 
            isDisabled={!isPrev}
        />
        <KeyboardEventHandler
            handleKeys={['right']}
            onKeyEvent={(key, e) => onNextClick(e)} 
            handleFocusableElements
            isDisabled={!isNext}
        />  
    </Container>
)}